import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const INSPECTIONS_INSPECTION_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inspections/completed',
        iconClass: 'fas fa-file-signature',
        name: 'ServicingService::Menu:CompletedEvents',
        parentName: 'ServicingService::Menu:ServicingService',
        layout: eLayoutType.application,
        requiredPolicy: 'ServicingService.Events.Page',
        order: 5
      },
    ]);
  };
}
